export default __webpack_public_path__ + "bitbucket-sign.png";